import { Injectable, Type } from '@angular/core';
import { WidgetType } from '../../util/WidgetType';

interface IconDefinition {
  provider: 'material' | 'app';
  name: string;
};

@Injectable()
export class ToolbarWidgetType extends WidgetType {
  public docked = true;

  constructor(type: Type<any>, name: string, public icon: string | IconDefinition, index?: number) {
    super(type, name, false, index);
  }

  public hasMaterialIcon() {
    return this.getIconProvider() === 'material';
  }

  public hasAppIcon() {
    return this.getIconProvider() === 'app';
  }

  public getIconProvider(): 'material' | 'app' {
    if (typeof this.icon === 'string') {
      return 'material';
    }

    return this.icon.provider;
  }

  public getIconName(): string {
    if (typeof this.icon === 'string') {
      return this.icon;
    }

    return this.icon.name;
  }

  public toggleActive() {
    this.docked = true;

    return super.toggleActive();
  }


  public deactivate() {
    this.docked = true;

    return super.deactivate();
  }

  public activate() {
    this.docked = true;

    return super.activate();
  }

  toggleDocked() {
    return this.docked = !this.docked;
  }

  dock() {
    this.docked = true;
  }

  undock() {
    this.docked = false;
  }
}
